// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format12 } from '../../constants';

/** Myanmar (Burma) */
const MM: PhoneNumberData = [95, 'MM', 8, format12, 10, '0 000 000 000'];

export default MM;
